module.exports = __webpack_public_path__ + "2f91a532545b6d5105107f01b7220855.png";